import { platformCategories } from "@/mocks/games";

export default function PlatformNav() {
  return (
    <section className="relative z-20 mx-auto -mt-10 max-w-6xl px-4 md:px-6">
      <div className="grid grid-cols-1 gap-4 rounded-xl bg-background-100 border border-background-200 p-5 sm:grid-cols-2 lg:grid-cols-5">
        {platformCategories.map((cat) => (
          <a
            key={cat.key}
            href={`#library`}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("library")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="group flex items-start gap-3 rounded-lg bg-background-50 p-4 transition-all hover:-translate-y-1 hover:bg-secondary-100"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-white transition-colors group-hover:bg-primary-600">
              <i className={`${cat.icon} text-xl`}></i>
            </span>
            <span>
              <span className="block text-sm font-bold text-foreground-900">{cat.name}</span>
              <span className="mt-1 block text-xs leading-5 text-foreground-500">{cat.desc}</span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}